'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'alarm-clock';
var width = 512;
var height = 512;
var aliases = [9200];
var unicode = 'f34e';
var svgPathData = ['M64 288a192 192 0 1 0 384 0 192 192 0 1 0 -384 0zM240 160l32 0 0 136c45.9 34.4 69.3 52 70.4 52.8l-19.2 25.6-12.8-9.6-64-48-6.4-4.8 0-152z', 'M378.3 45c-10.4-5.2-21.1-9.8-32.2-13.7 17.4-19.2 42.6-31.3 70.6-31.3 52.6 0 95.2 42.6 95.2 95.2 0 21.8-7.3 41.9-19.7 58-5.8-10.1-12.2-19.9-19.3-29.2 4.4-8.6 6.9-18.4 6.9-28.8 0-34.9-28.3-63.2-63.2-63.2-14.5 0-27.8 4.8-38.4 13zM19.7 153.2c-12.3-16.1-19.7-36.2-19.7-58 0-52.6 42.6-95.2 95.2-95.2 28 0 53.2 12.1 70.6 31.3-11.1 3.9-21.8 8.5-32.2 13.7-10.6-8.2-24-13-38.4-13-34.9 0-63.2 28.3-63.2 63.2 0 10.4 2.5 20.2 6.9 28.8-7 9.3-13.5 19-19.3 29.2zM448 288a192 192 0 1 0 -384 0 192 192 0 1 0 384 0zM402.7 457.3C363.4 491.4 312.1 512 256 512s-107.4-20.6-146.7-54.7C69.5 497.1 49.1 517.5 48 518.6L25.4 496C26.5 494.9 46.9 474.5 86.7 434.7 52.6 395.4 32 344.1 32 288 32 164.3 132.3 64 256 64S480 164.3 480 288c0 56.1-20.6 107.4-54.7 146.7l50 50 11.3 11.3-22.6 22.6-11.3-11.3-50-50zM272 176l0 120c45.9 34.4 69.3 52 70.4 52.8l-19.2 25.6-12.8-9.6-64-48-6.4-4.8 0-152 32 0 0 16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faAlarmClock = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;